export default "__VITE_ASSET__aoDAs8DW__"